import React from "react";
import { Gauge, Waves, Wind, Eye, CloudRain } from "lucide-react";
import { calculateDailySailing } from "@/lib/dailySailing";
import { getTranslationsForLanguage } from "@/i18n";

const levelClasses = {
  Ideal: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30 dark:text-emerald-300",
  Good: "bg-primary/10 text-primary border-primary/30",
  Risky: "bg-amber-500/10 text-amber-700 border-amber-500/30 dark:text-amber-300",
  "Stay in port": "bg-red-500/10 text-red-700 border-red-500/30 dark:text-red-300",
};

export default function ConditionScoreCard({ weather, loading, lang = "en" }) {
  const t = getTranslationsForLanguage(lang, "dailyBriefing").score;
  if (loading) return <div className="rounded-[2rem] border border-border bg-card p-6">{t.loading}</div>;
  const summary = calculateDailySailing(weather);
  const metrics = [
    { icon: Wind, label: t.metrics.wind, value: `${Math.round(summary.wind)} kt` },
    { icon: Waves, label: t.metrics.waves, value: `${summary.wave.toFixed(1)} m` },
    { icon: Eye, label: t.metrics.visibility, value: `${summary.visibilityKm.toFixed(0)} km` },
    { icon: CloudRain, label: t.metrics.rain, value: `${summary.rain.toFixed(1)} mm` },
  ];

  return (
    <article className="rounded-[2rem] border border-border bg-card p-6 shadow-xl shadow-ocean/5">
      <div className="flex items-start justify-between gap-4">
        <div><p className="text-sm font-black uppercase tracking-[0.18em] text-primary">{t.eyebrow}</p><h3 className="mt-2 text-3xl font-black">{t.title}</h3></div>
        <Gauge className="h-9 w-9 text-primary" />
      </div>
      <div className="mt-6 flex items-end gap-4"><span className="text-6xl font-black text-foreground">{summary.score}</span><span className="mb-2 text-muted-foreground">{t.outOf}</span></div>
      <span className={`mt-4 inline-flex rounded-full border px-4 py-2 text-sm font-black ${levelClasses[summary.level]}`}>{t.levels[summary.level]}</span>
      <div className="mt-6 grid grid-cols-2 gap-3">
        {metrics.map(({ icon: Icon, label, value }) => <div key={label} className="rounded-2xl bg-background/70 p-4"><Icon className="h-5 w-5 text-primary" /><p className="mt-2 text-xs font-bold text-muted-foreground">{label}</p><b>{value}</b></div>)}
      </div>
    </article>
  );
}